import { useParams } from 'react-router-dom'
import { GuestQuickActions } from '../components/GuestQuickActions'
import { GuestTablePage } from './GuestTablePage'

export function GuestTableExperience(){
  const {token=''}=useParams()
  return <><GuestTablePage/><GuestQuickActions token={token}/></>
}
